import { sharedReactorWebsocket as ws } from 'reactor-js-core/dist/reactor';

var configs = require('../config');

const env = process.env.NODE_ENV;
const config = env === 'development' ? configs.dev : configs.build;

export default function(vue_instance) {
  var isErrorCurrently = false;       //boolean that says if last websocket connection has failed
  var proxyDetectedDialog = null;     //any currently displayed proxy detection dialog
  var proxyDetectionThreshold = 1;    //how many retries we should do before displaying the proxy detection dialog
  var proxyDetectionCount = 0;        //keep count how many times websocket has failed but normal requests succeed

  ws.onErrorBeforeOpen = () => {
    isErrorCurrently = true;
    if (proxyDetectedDialog == null) {
      var connectivity_test = new XMLHttpRequest();
      connectivity_test.onreadystatechange = () => {
        if (connectivity_test.readyState === XMLHttpRequest.DONE) {
          if (connectivity_test.status === 426) {
            if (!isErrorCurrently) return;    //websocket has connected successfully while we were waiting for response

            //all is good with normal HTTP requests so seems like there's a proxy present
            proxyDetectionCount++;
            if (proxyDetectionCount > proxyDetectionThreshold) {
              proxyDetectedDialog = vue_instance.alert({ trusted_html: vue_instance.$t('proxy_detected') }, () => {
                proxyDetectedDialog = null;
                if (isErrorCurrently) {
                  //reload page if the error is still on
                  window.location.reload();
                }
              });
            }
          }
        }
      }

      var connect_url = config.httpapiEndpoint.replace("ws://", "http://");
      connect_url = connect_url.replace("wss://", "https://");
      connectivity_test.open("GET", connect_url + "/connectivitytest?connection_id=" + ws.websocketId);
      connectivity_test.send();
    }
  }
  let callback_function = ws.addOnConnectedCallback(() => {
    isErrorCurrently = false;
    proxyDetectionCount = 0;
    if (proxyDetectedDialog != null) {
      proxyDetectedDialog.dismiss();      //dismiss dialog automatically if websocket succeeds
      proxyDetectedDialog = null;
    }
  });

  return {
    shutdown() {
      ws.removeOnConnectedCallback(callback_function);
    }
  }
}


// WEBPACK FOOTER //
// ./src/proxydetection.js